<template>
  <div class="box box-primary">
    <div class="box-header with-border">
      <h3 class="box-title">
        {{ $t("label.editProvince") }}
      </h3>
      <div class="pull-right box-tools">
        <a
          class="btn btn-default btn-sm"
          @click="$router.back()"
        >
          <i class="fa fa-arrow-circle-left" /> {{ $t("button.back") }}
        </a>
      </div>
    </div>
    <div class="box-body">
      <province-form />
    </div>
  </div>
</template>

<script>
import ProvinceForm from './Form'

export default {
  name: 'Edit',
  components: { ProvinceForm },
  metaInfo () {
    return {
      title: this.$t('string.editNewProvince'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  }
}
</script>

<style scoped></style>
